module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Type</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-sm-12 col-md-4 nopadding-r\" style=\"width: 110x; min-width: 110px;\">\r\n        <input type=\"radio\" class=\"type\" name=\"type\" value=\"dropdown\"> Drop-down\r\n    </div>\r\n\r\n    <div class=\"col-sm-12 col-md-5 nopadding-l\">\r\n        <input type=\"radio\" class=\"type\" name=\"type\" value=\"list\"> List\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}